
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator';
import { CacheStore } from '../services/CacheStore';

@Component({})
export default class extends Vue {
  @Prop({ type: Array, required: true }) readonly enabled!: string[];

  @Prop(Boolean) readonly default!: boolean;

  @Provide() readonly cacheStore = this.default
    ? CacheStore.default
    : new CacheStore();

  beforeDestroy() {
    const { cacheStore } = this;
    this.enabled.forEach(key => {
      cacheStore.delete(key);
    });
  }

  render() {
    return this.$slots.default;
  }

  @Watch('enabled', { immediate: true })
  onEnabledChanged(value: string[], old: string[] | undefined) {
    const { cacheStore } = this;
    const newSet = new Set();
    if (value?.length) {
      value.forEach(key => newSet.add(key));
    }
    if (Array.isArray(old)) {
      old.forEach(key => {
        if (newSet.has(key)) {
          return;
        }
        cacheStore.delete(key);
      });
    }
    if (value?.length) {
      value.forEach(key => {
        cacheStore.enable(key);
      });
    }
  }
}
